import React from "react";

import logoWhite from '../new-images/dobbi-logo-white.png'
import logoGreen from '../new-images/dobbi-logo-green.png'
import logoD from '../new-images/dobbi-logo-d.png'

const homeLink = { en: 'https://dobbi.com/en/', nl: 'https://dobbi.com/nl/' }

export const Logo = props => {
  const lang = localStorage.getItem("lang");
  const logo = props.whiteHeader ? logoGreen : logoWhite
  return !props.wv ? (
    // eslint-disable-next-line
    <a className="logo-container">
      <img src={props.logo || logo} alt="" className="dobbi-logo" />
    </a>
  ) : (
      <a className="logo-container" href={homeLink[lang]}>
        <img src={props.logo || logo} alt="" className="dobbi-logo" />
        <img src={logoD} alt="" className="dobbi-logo-mobile" />
      </a>
    );
};
